import { AxiosRequestConfig } from 'axios'
import { getUserToken } from '@auth/auth.localstorage'

export const requestInterceptor = (config: AxiosRequestConfig) => {
  const token = getUserToken()

  const defaultHeaders: { [key: string]: string } = {
    'Content-Type': 'application/json',
    ...(!!token && { Authorization: `Bearer ${token}` }),
  }

  const headers = { ...defaultHeaders, ...config.headers }

  return { ...config, headers }
}
